// extracted by mini-css-extract-plugin
export default {"facultysec":"facultyinchargesec_facultysec__yhGsU"};